// extracted by mini-css-extract-plugin
export default {"SidebarNavErrorStatus":"SidebarNavErrorStatus2vfbcvsn77V7"};